export class TicketPrintRequest {
  ticketId: number;
  reprintFlag: boolean;
  requestId: string;
  ticketPrintQueue: string;
  sendOrderEmails: boolean;

  constructor(
    ticketId: number,
    reprintFlag: boolean,
    requestId: string,
    selectedPrinter: string,
    sendOrderEmails?: boolean
  ) {
    this.ticketId = ticketId;
    this.reprintFlag = reprintFlag;
    this.requestId = requestId;
    this.ticketPrintQueue = selectedPrinter;
    this.sendOrderEmails = sendOrderEmails ?? false;
  }
}
